import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

export default function Profile() {
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const [status, setStatus] = useState("Signing you in…");

  useEffect(() => {
    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
    const sessionId = params.get("session_id");

    (async () => {
      if (!sessionId) {
        // No session id: user already signed in, or opened /profile directly.
        const u = await refreshUser();
        if (u) navigate("/app", { replace: true });
        else {
          setStatus("No session found. Redirecting…");
          setTimeout(() => navigate("/", { replace: true }), 800);
        }
        return;
      }
      try {
        await api.post("/auth/session", { session_id: sessionId });
        // Clear the hash so the token doesn't linger in the URL history.
        window.history.replaceState({}, "", "/profile");
        await refreshUser();
        toast.success("Signed in");
        navigate("/app", { replace: true });
      } catch (e) {
        const msg = e?.response?.data?.detail || "Sign-in failed";
        toast.error(msg);
        setStatus(msg);
        setTimeout(() => navigate("/", { replace: true }), 1500);
      }
    })();
  }, [navigate, refreshUser]);

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-white"
      data-testid="profile-loading"
    >
      <div className="flex flex-col items-center gap-4">
        <div className="w-8 h-8 border-2 border-gray-900 border-t-transparent rounded-full animate-spin" />
        <p className="text-sm text-gray-500 tracking-wide">{status}</p>
      </div>
    </div>
  );
}
